import { useEffect, useState } from "react";
import clsx from "clsx";

// MUI
import { Paper, SxProps, Typography } from "@mui/material";

// Icons
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

type TitleExpandibleToolbarProps = {
	title?: string;
	titleClasses?: string;
	sx?: SxProps;
	sxContainer?: SxProps;
	collapsed?: boolean;
	collapsible?: boolean;
	onClick?: (collapsed: boolean) => void;
};
export default function TitleExpandibleToolbar(props: TitleExpandibleToolbarProps) {
	const { title, titleClasses, sx, sxContainer, collapsed, collapsible, onClick } = props;
	const [closed, setClosed] = useState(true);

	const handleOnClick = () => {
		setClosed((prev) => !prev);
		onClick?.(!closed);
	};

	useEffect(() => {
		setClosed(Boolean(collapsed));
		return () => {
			setClosed(true);
		};
	}, [collapsed]);

	return (
		<Paper
			elevation={0}
			className="full-collapse-area-button"
			sx={{
				...sxContainer,
				justifyContent: "left",
				textTransform: "capitalize",
				borderRadius: "0px",
				"&:hover": { backgroundColor: "var(--gray-background)" },
			}}
			onClick={handleOnClick}
		>
			<Typography
				className={clsx({
					[titleClasses ?? ""]: Boolean(titleClasses),
				})}
				sx={sx}
			>
				{title ?? ""}
				{collapsible && (
					<ArrowForwardIosRoundedIcon
						className={closed ? "arrow-icon-point-down" : "arrow-icon-point-up"}
						sx={{ marginLeft: "10px" }}
					/>
				)}
			</Typography>
		</Paper>
	);
}
